import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Overview = lazy(() => import('./Overview'));

const OverviewConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
		}
	},
	routes: [
		{
			path: '/eo/overview',
			element: <Overview />,
			auth: authModules.eo_default
		}
	]
};

export default OverviewConfig;
